query self {
  self {
    id
    capabilities {
      canCreateAutoQuote {
        answer
        reasons
        states
      }
    }
    user {
      id
      firstName
      lastName
      email
      roles
      states
      autoStates
      isOpenly
      agency {
        id
        shortID
        name
        notificationEmail
        reportsEmail
        commissionsEmail
        extraCommissionsEmails
        email
        phone
        website
        streetLine1
        streetLine2
        city
        state
        zip
        appointedStates
        autoAppointedStates
        ivansConnected
        principalEmail
        canCreateAutoQuote
      }
    }
    permissions
    zendeskChatJWT
  }
}
